import _ from 'lodash';
import produce from 'immer';
import { getPathToCardInSteps } from 'common/utils/facades/utils';
import {
	SET_STORY,
	SET_STORY_ELEMENTS,
	SET_STORY_CARD_DATA,
	SET_STORY_SETTINGS,
	SET_STORY_SYMBOLS,
} from 'client/constants/actions';
import { BBModel, CardData, StoryModel, StorySettingsType, StorySymbols } from 'types/story';
import { setStory, setStoryCardData, setStoryElements, setStorySettings, setStorySymbols } from 'client/actions';
import initialState from './initial-state';

type Action = ReturnType<
	| typeof setStorySymbols
	| typeof setStorySettings
	| typeof setStoryElements
	| typeof setStory
	| typeof setStoryCardData
>;

export default function storyReducer(state = initialState, action: Action): typeof initialState {
	return produce(state, oldState => {
		/* eslint-disable no-param-reassign */

		const { type, payload } = action;

		if (type === SET_STORY) {
			Object.assign(oldState, payload as StoryModel);
		}

		if (type === SET_STORY_ELEMENTS) {
			(oldState as StoryModel).storyVersions.latest.data.elements = payload as BBModel[];
		}

		if (type === SET_STORY_SYMBOLS) {
			(oldState as StoryModel).storyVersions.latest.data.symbols = payload as StorySymbols;
		}

		if (type === SET_STORY_SETTINGS) {
			(oldState as StoryModel).storyVersions.latest.settings = payload as StorySettingsType;
		}

		if (type === SET_STORY_CARD_DATA) {
			const { steps } = (oldState as StoryModel).storyVersions.latest.data;
			const cardPath = getPathToCardInSteps(steps, (payload as CardData)._id);
			_.set(oldState, `storyVersions.latest.data.steps.${cardPath}`, payload);
		}
		/* eslint-enable no-param-reassign */
	});
}
